import React from "react";
import { SanityImageSourceExt } from "../models/shared/SanityImageSourceExt";
import { replaceWithUnicode } from "../shared/string";
import { ImagePresetCollection, validImage } from "../utilities/image";
import { Picture } from "./Picture";

const imagePresets: ImagePresetCollection = {
  default: {
    height: 256,
    width: 480
  },
  md: {
    height: 256,
    width: 1024
  },
  lg: {
    height: 530,
    width: 1440
  },
  "2xl": {
    height: 480,
    width: 1920
  },
  "3xl": {
    height: 512,
    width: 2560
  }
};

export interface Props {
  titleOverlay?: string;
  image?: SanityImageSourceExt;
}

const Hero = ({ titleOverlay, image }: Props) => {
  if (validImage(image)) {
    return (
      <div className="relative mb-4 lg:mb-12">
        <div
          className="
            h-hero-image-mobile max-h-hero-image-max 
            lg:h-hero-image 
            2xl:h-hero-image-2xl
            3xl:h-hero-image-3xl
          "
        >
          <Picture
            image={image}
            imgClassName="z-0 w-full h-full relative object-cover object-center lg:slice-bottom lg:z-1"
            presets={imagePresets}
          />
        </div>
        {titleOverlay && (
          <div className="header-div z-10 px-7 lg:px-8 mx-auto relative -mt-8 lg:-mt-20 uppercase">
            <div className="header-div z-10 px-7 lg:px-8 mx-auto relative -mt-8 lg:-mt-20 uppercase">
              <h1 className="inline text-white inline-size-full break-words">
                <span className="header-multiline-text-background">
                  {replaceWithUnicode(titleOverlay)}
                </span>
              </h1>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return null;
  }
};

export default Hero;
